const i18n = {
    ResolutionResultWithDate: {
		1 : 'Результат рассмотрения обращения от {0}',
		0 : 'Вынік разгляду звароту ад {0}'
	},
	IntermediateResolutionResultWithDate: {
		1 : 'Промежуточный результат рассмотрения обращения от {0}',
		0 : 'Прамежкавы вынік разгляду звароту ад {0}'
	},
    ReviewResultWithDate: {
		1 : 'Результат рассмотрения обращения от {0}',
		0 : 'Вынік разгляду звароту ад {0}'
	},
    signer: {
		1 : 'Подписант:\n{0}',
		0 : 'Падпісант:\n{0}'
	},
    CaseNumber: {
		1 : 'Номер сформированного дела',
		0 : 'Нумар сфармаванага справы'
	},
    AnswerRegNumber: {
		1 : 'Регистрационный номер ответа',
		0 : 'Рэгістрацыйны нумар адказу'
	},
    ReviewResult: {
		1 : 'Результат рассмотрения обращения',
		0 : 'Вынік разгляду звароту'
	},
}
export default i18n